import styled from '@emotion/styled'
import React from 'react'

const H1 = styled.h1`
  color: #414141;
  font-size: 22px;
  margin: 0 0 15px;
  border: none;
  display: block;
  p {
    width: 100%;
    margin: 0 0 3px;
    padding: 0 0 15px;
    display: inline-block;
    position: relative;
    border-bottom: solid 3px #e5e5e5;
    span {
      line-height: 1.6em;
      /* display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden; */
    }
    &:before {
      position: absolute;
      bottom: -3px;
      left: 0;
      width: 20%;
      height: 3px;
      content: '';
      background: #77d7c9;
    }
  }
`

type Props = {
  /** クラス名 */
  className?: string
  /** タイトル */
  label: string
}

/**
 * コラム用共通H1コンポーネント
 * @param props
 * @constructor
 */
const ColumnH1 = (props: Props): JSX.Element => {
  const { className = '' } = props

  return (
    <H1 className={className}>
      <p>
        <span>{props.label}</span>
      </p>
    </H1>
  )
}

export default ColumnH1
